import React from 'react';
import './PageHeader.css';

/**
 * PageHeader – title + subtitle banner at top of each page
 */
export default function PageHeader({ title, subtitle, children }) {
  return (
    <div className="page-header fade-up">
      <div className="page-header__text">
        <h1 className="page-header__title">{title}</h1>
        {subtitle && <p className="page-header__sub">{subtitle}</p>}
      </div>
      {children && <div className="page-header__actions">{children}</div>}
    </div>
  );
}
